<template>
  <form>
    <md-card v-if="currentCredit">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 v-if="isAdmin()" class="title">
          Crédito con ID: {{ currentCredit.creditId }} de
          <small>{{ currentCredit.capAccount.fullName }}</small>
        </h4>
        <h4 v-else class="title">
          Solicitud de Crédito
          <small
            >Día
            {{ Constants.formatDate(currentCredit.startCountingDate) }}</small
          >
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Documento</label>
              <md-input
                disabled
                v-model="currentCredit.capAccount.documentValue"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Correo</label>
              <md-input
                disabled
                v-model="currentCredit.capAccount.email"
                type="email"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Celular</label>
              <md-input
                disabled
                v-model="currentCredit.capAccount.cellphone"
              ></md-input>
            </md-field>
          </div>

          <div
            v-if="isAdmin()"
            class="md-layout-item md-small-size-100 md-size-33"
          >
            <md-field>
              <label>Estado del Cliente</label>
              <md-input
                disabled
                v-model="currentCredit.capAccount.capCurrentStatus.stateName"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Categoría</label>
              <md-input
                disabled
                v-bind:value="
                  currentCredit.capAccount.capClientCategory.catName
                "
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Puntaje</label>
              <md-input
                disabled
                v-bind:value="clientScore.score"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Monto Solicitado</label>
              <md-input disabled v-model="moneyBase"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Cobros Adicionales</label>
              <md-input disabled v-model="additionalPayments"></md-input>
            </md-field>
          </div>
          <div
            v-if="arrearsPayments"
            class="md-layout-item md-small-size-100 md-size-33"
          >
            <md-field>
              <label>Cobros por Mora</label>
              <md-input disabled v-model="arrearsPayments"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Total a Pagar</label>
              <md-input disabled v-model="sumTotal"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Fecha de Solicitud/Desembolso</label>
              <md-input
                disabled
                v-model="currentCredit.startCountingDate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Plazo de Pago en Días</label>
              <md-input disabled v-model="currentCredit.dayLimit"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Fecha de Pago</label>
              <md-input disabled v-model="currentCredit.paymentDate"></md-input>
            </md-field>
          </div>
          <div
            v-if="currentCredit.payAgreementDate"
            class="md-layout-item md-small-size-100 md-size-33"
          >
            <md-field>
              <label>Fecha de Acuerdo de Pago</label>
              <md-input
                disabled
                v-model="currentCredit.payAgreementDate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Estado del Crédito</label>
              <md-input
                disabled
                v-model="currentCredit.capCurrentStatus.stateName"
              ></md-input>
            </md-field>
          </div>
          <div
            v-if="statusList.length && isAdmin()"
            class="md-layout-item md-size-33 md-small-size-100"
          >
            <md-field class="md-layout-item">
              <label for="pages">Actualizar estado a</label>
              <md-select v-model="stateChange" name="pages">
                <md-option
                  v-for="item in statusList"
                  :key="item.id"
                  :value="JSON.stringify(item)"
                  >{{ item.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div
            v-if="
              !isAdmin() &&
                currentCredit.capCurrentStatus.stateId !=
                  getCreditPaidStatusId() &&
                currentCredit.capCurrentStatus.stateId !=
                  getCreditDeniedStatusId()
            "
            class="md-layout-item md-small-size-100 md-size-33"
          >
            <md-button @click="howToPay()" class="md-raised md-info mt-4"
              >¿Cómo pagar?</md-button
            >
          </div>

          <div class="md-layout-item md-size-100 text-right">
            <md-button
              v-if="isAdmin() && proofPresignedUrl"
              @click="revokeProof()"
              class="md-raised md-info mt-4"
              >Revocar Comprobante</md-button
            >
            <md-button
              v-if="isAdmin()"
              :disabled="!stateChange"
              @click="updateStatus()"
              class="md-raised md-info mt-4"
              >Actualizar estado</md-button
            ><md-button
              :disabled="loadingSign"
              v-else-if="canBeSigned()"
              @click="sign()"
              class="md-raised md-info mt-4"
              >Firmar</md-button
            >
            <md-button
              v-if="
                !isAdmin() &&
                  !proofPresignedUrl &&
                  currentCredit.capCurrentStatus.stateId !=
                    getCreditPaidStatusId() &&
                  currentCredit.capCurrentStatus.stateId !=
                    getCreditDeniedStatusId()
              "
              :disabled="!isProofable()"
              @click="loadProof()"
              class="md-raised md-info mt-4"
              >Adjuntar Comprobante</md-button
            >
            <h4 v-else-if="proofPresignedUrl">
              Comprobante adjunto:
              <a class="card-title" :href="proofPresignedUrl" target="_blank"
                >Revisar</a
              >
            </h4>

            <md-card v-if="canRequestPayAgreement()">
              <md-card-content>
                <collapse
                  :collapse="[this.payAgreementTitle, '']"
                  icon="keyboard_arrow_down"
                  color-collapse="success"
                >
                  <template slot="md-collapse-pane-1">
                    <p>
                      Te encuentas en mora, sin embargo puedes realizar un
                      acuerdo para resolver una nueva fecha de pago.
                    </p>
                    <md-datepicker
                      :md-disabled-dates="disabledDates"
                      v-model="payAgreementDate"
                    />
                    <md-button
                      @click="createPayAgreement()"
                      class="md-raised md-info mt-4"
                      >Realizar acuerdo</md-button
                    >
                  </template>
                </collapse>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div class="md-layout-item text-center mx-auto md-small-size-100">
      <h4 v-if="!imageRegular" class="card-title">
        Contrato sin generar
      </h4>
      <h4 v-else>
        {{ contractTitle }}
        <a class="card-title" :href="routePresignedUrl" target="_blank"
          >Revisar</a
        >
      </h4>
      <div class="file-input">
        <div v-if="!imageRegular">
          <div class="image-container">
            <img :src="regularImg" title="" />
          </div>
        </div>
        <div class="image-container" v-else>
          <img :src="imageRegular" />
        </div>
        <div
          v-if="
            isAdmin() &&
              currentCredit &&
              currentCredit.capCurrentStatus.stateId ==
                getCreditApprovedStatusId() &&
              !this.keyName.endsWith('firmado.pdf')
          "
          class="button-container"
        >
          <md-button
            @click="generatePDF"
            :disabled="loadingContract"
            class="md-info md-round md-fileinput"
          >
            <template v-if="!imageRegular"
              >Generar y adjuntar Contrato</template
            >
          </md-button>
        </div>
        <div v-else-if="canBeSigned()" class="button-container">
          <md-field>
            <label>Firmar con código</label>
            <md-input v-model="creditCode"></md-input>
          </md-field>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import gql from "graphql-tag";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import Constants from "../../constants";
import download from "downloadjs";
import axios from "axios";
import Swal from "sweetalert2";
import { Collapse } from "@/components";
export default {
  components: { Collapse },
  name: "edit-profile-form",
  props: {
    regularImg: {
      type: String,
      default: "./img/capital77/file-icon.webp"
    },
    headerColor: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      currentCredit: null,
      stateChange: null,
      statusList: [],
      contractTitle: null,
      loadingContract: false,
      loadingSign: false,
      routePresignedUrl: null,
      imageRegular: null,
      multipartFile: new FormData(),
      keyName: null,
      creditCode: null,
      proofPresignedUrl: null,
      modalPayAgreement: false,
      payAgreementDate: new Date(new Date().getTime() + 1000 * 3600 * 24),
      disabledDates: date => {
        return (
          Constants.daysOfDifference(new Date(), date) > 20 ||
          Constants.daysOfDifference(new Date(), date) < 1
        );
      },
      payAgreementTitle: null,
      clientScore: 0,
      additionalPayments: null,
      arrearsPayments: null,
      moneyBase: null,
      sumTotal: 0,
      Constants: Constants
    };
  },
  methods: {
    canRequestPayAgreement() {
      return (
        !this.isAdmin() &&
        this.currentCredit.capCurrentStatus.stateId ==
          this.getCreditInArrearsStatusId() &&
        this.currentCredit.payAgreementDate == null &&
        this.currentCredit.arrearsPayments >= 7000
      );
    },
    revokeProof() {
      this.$apollo.mutate({
        mutation: gql`
          mutation revokeProof($creditId: Int!) {
            revokeProof(creditId: $creditId)
          }
        `,
        variables: {
          creditId: this.currentCredit.creditId
        },
        update: (cache, mutationResult) => {
          Swal.fire({
            title: "Comprobante revocado",
            text: mutationResult.data.revokeProof,
            confirmButtonClass: "md-button md-primary",
            buttonsStyling: false
          }).then(() => {
            this.$router.go();
          });
        }
      });
    },
    createPayAgreement() {
      Swal.fire({
        title: "Confirmación de Acuerdo de Pago",
        text:
          "¿Seguro que deseas realizar un acuerdo de pago para el día " +
          Constants.formatDateJS(this.payAgreementDate) +
          "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-primary",
        cancelButtonClass: "md-button md-info",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$apollo
            .mutate({
              mutation: gql`
                mutation makePayAgreement(
                  $creditId: Int!
                  $paymentDate: LocalDate!
                ) {
                  makePayAgreement(
                    creditId: $creditId
                    paymentDate: $paymentDate
                  ) {
                    creditId
                  }
                }
              `,
              variables: {
                creditId: this.currentCredit.creditId,
                paymentDate: this.payAgreementDate
              },
              update: (cache, mutationResult) => {
                Swal.fire({
                  title: "Acuerdo de Pago",
                  text:
                    "Has realizado correctamente un acuerdo de pago, asegúrate de cumplirlo.",
                  confirmButtonClass: "md-button md-primary",
                  buttonsStyling: false
                }).then(() => {
                  this.$router.go();
                });
              }
            })
            .catch(error => {
              Constants.catchError(
                error,
                this.$apollo.provider.defaultClient,
                this,
                false
              );
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
    },
    noticeModalHide: function() {
      this.modalPayAgreement = false;
    },
    loadProof() {
      this.$router.push("/messagePage/attach/" + this.currentCredit.creditId);
    },
    canBeSigned() {
      return (
        !this.isAdmin() &&
        this.imageRegular &&
        this.currentCredit &&
        this.getCreditApprovedStatusId() ==
          this.currentCredit.capCurrentStatus.stateId &&
        this.keyName &&
        !this.keyName.endsWith("firmado.pdf")
      );
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    getCreditApprovedStatusId() {
      return Constants.STATUS_CREDIT_APPROVED;
    },
    getCreditInArrearsStatusId() {
      return Constants.STATUS_CREDIT_IN_ARREARS;
    },
    getCreditPaidStatusId() {
      return Constants.STATUS_CREDIT_PAID;
    },
    getCreditDeniedStatusId() {
      return Constants.STATUS_CREDIT_DENIED;
    },
    showPayAgreement() {
      this.modalPayAgreement = true;
    },
    isProofable() {
      var proofable = false;
      if (
        this.currentCredit.capCurrentStatus.stateId ==
        Constants.STATUS_CREDIT_OWED
      )
        proofable = true;
      else if (
        this.currentCredit.capCurrentStatus.stateId ==
        Constants.STATUS_CREDIT_IN_ARREARS
      )
        proofable = true;
      else if (
        this.currentCredit.capCurrentStatus.stateId ==
        Constants.STATUS_CREDIT_PAY_AGREEMENT
      )
        proofable = true;
      return proofable;
    },
    howToPay() {
      Swal.fire({
        title: "Adjuntar Comprobante de Pago",
        text:
          "Una vez tu crédito sea desembolsado, al borde inferior de esta página se habilitará el botón 'Adjuntar Comprobante'. A continuación las opciones de pago.",
        confirmButtonClass: "md-button md-primary",
        buttonsStyling: false
      }).then(() => {
        Swal.fire({
          title: "Opción #1",
          text:
            "Transferencia bancaria a Cuenta de Ahorros Bancolombia #74591205386 a nombre de CAPITAL77 S.A.S (NIT 901144668)",
          confirmButtonClass: "md-button md-primary",
          buttonsStyling: false
        }).then(() => {
          Swal.fire({
            title: "Opción #2",
            text:
              "Pago en corresponsal bancario a Cuenta de Ahorros Bancolombia #74591205386 a nombre de CAPITAL77 S.A.S",
            confirmButtonClass: "md-button md-primary",
            buttonsStyling: false
          });
        });
      });
    },
    sign() {
      if (this.creditCode) {
        this.loadingSign = true;
        this.$apollo
          .query({
            query: gql`
              query signDeal(
                $creditId: Int!
                $securityCode: String!
                $dateFormatted: String!
              ) {
                signDeal(
                  creditId: $creditId
                  securityCode: $securityCode
                  dateFormatted: $dateFormatted
                )
              }
            `,
            variables: {
              creditId: this.currentCredit.creditId,
              securityCode: this.creditCode,
              dateFormatted: this.formatDateJS()
            }
          })
          .then(data => {
            this.keyName = data.data.signDeal;
            this.$apollo
              .query({
                query: gql`
                  query getS3File($keyName: String!) {
                    getPresignedUrl(keyName: $keyName)
                  }
                `,
                variables: {
                  keyName: this.keyName
                }
              })
              .then(data => {
                this.routePresignedUrl = data.data.getPresignedUrl;
                this.imageRegular = "./img/capital77/file-check-icon.webp";
                axios
                  .get(data.data.getPresignedUrl, {
                    responseType: "blob"
                  })
                  .then(response => {
                    this.loadingSign = false;
                    const content = response.headers["content-type"];
                    var partsRouteFile = this.keyName.split("/");
                    download(
                      response.data,
                      partsRouteFile[partsRouteFile.length - 1],
                      content
                    );
                  })
                  .catch(e => {
                    this.loadingSign = false;
                    console.log(e);
                  });
              });
          })
          .catch(error => {
            this.loadingSign = false;
            Constants.catchError(
              error,
              this.$apollo.provider.defaultClient,
              this,
              false
            );
          });
      } else
        Swal.fire({
          title: "Escribe el código",
          text:
            "Para firmar el contrato, debes escribir el código en la sección: Firmar con código",
          confirmButtonClass: "md-button md-primary",
          buttonsStyling: false
        });
    },
    isAdmin() {
      return Constants.getUserType() == Constants.ADMIN;
    },
    formatDate(input) {
      return Constants.formatDateJS(input);
    },
    formatDateJS() {
      var dateF = Constants.formatDateJS(new Date());
      console.log(dateF);
      return dateF;
    },
    generatePDF() {
      this.loadingContract = true;
      this.$apollo
        .query({
          query: gql`
            query generateDeal($creditId: Int!) {
              generateDeal(creditId: $creditId)
            }
          `,
          variables: {
            creditId: this.currentCredit.creditId
          }
        })
        .then(data => {
          this.keyName = data.data.generateDeal;
          this.$apollo
            .query({
              query: gql`
                query getS3File($keyName: String!) {
                  getPresignedUrl(keyName: $keyName)
                }
              `,
              variables: {
                keyName: this.keyName
              }
            })
            .then(data => {
              this.loadingContract = false;
              this.routePresignedUrl = data.data.getPresignedUrl;
              this.imageRegular = "./img/capital77/file-check-icon.webp";
            })
            .catch(error => {
              this.loadingContract = false;
              Constants.catchError(
                error,
                this.$apollo.provider.defaultClient,
                this,
                false
              );
            });
        })
        .catch(error => {
          this.loadingContract = false;
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            false
          );
        });
    },
    updateStatus() {
      Swal.fire({
        title: "Confirmación de Actualización de estado",
        text:
          "¿Seguro que deseas actualizar el estado del crédito a " +
          JSON.parse(this.stateChange).name +
          "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-primary",
        cancelButtonClass: "md-button md-info",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$apollo
            .mutate({
              mutation: gql`
                mutation updateCredit($creditId: Int!, $statusId: Int!) {
                  updateCredit(creditId: $creditId, statusId: $statusId) {
                    creditId
                    dayLimit
                    moneyBase
                    capCurrentStatus {
                      stateName
                    }
                  }
                }
              `,
              variables: {
                creditId: this.$route.params.creditId,
                statusId: JSON.parse(this.stateChange).id
              },
              update: (cache, mutationResult) => {
                let creditResult = mutationResult.data.updateCredit;
                if (
                  JSON.parse(this.stateChange).id ==
                  Constants.STATUS_CREDIT_PAID
                ) {
                  this.$apollo
                    .mutate({
                      mutation: gql`
                        mutation checkScoreForCategory($accountId: Int!) {
                          checkScoreForCategory(accountId: $accountId)
                        }
                      `,
                      variables: {
                        accountId: this.currentCredit.capAccount.accountId
                      },
                      update: (cache, mutationResult) => {
                        this.creditUpdated(creditResult);
                      }
                    })
                    .catch(error => {
                      Constants.catchError(
                        error,
                        this.$apollo.provider.defaultClient,
                        this,
                        false
                      );
                    });
                } else this.creditUpdated(creditResult);
              }
            })
            .catch(error => {
              Constants.catchError(
                error,
                this.$apollo.provider.defaultClient,
                this,
                false
              );
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
    },
    creditUpdated(creditResult) {
      Swal.fire({
        title: "Crédito actualizado",
        text:
          "Crédito actualizado con estado " +
          creditResult.capCurrentStatus.stateName,
        confirmButtonClass: "md-button md-primary",
        buttonsStyling: false
      }).then(() => {
        this.$router.go();
      });
    },

    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      var partsName = file.name.split(".");
      var extension = partsName[partsName.length - 1];
      if (
        extension.toLowerCase() == "jpeg" ||
        extension.toLowerCase() == "png" ||
        extension.toLowerCase() == "jpg"
      ) {
        reader.onload = e => {
          vm.imageRegular = e.target.result;
          vm.multipartFile.set("file", file, file.name);
        };

        reader.readAsDataURL(file);
      } else if (file.size < 5000000) {
        reader.onload = e => {
          vm.imageRegular = "./img/capital77/file-check-icon.webp";
          vm.multipartFile.set("file", file, file.name);
        };

        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "Tamaño no permitido",
          text: "Sólo puedes cargar archivos menores a 5 Mb",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (e.target.name) {
        this.createImage(files[0], "circle");
      } else {
        this.createImage(files[0]);
      }
    }
  },
  mounted() {
    this.$apollo
      .query({
        query: gql`
          query findCreditById($id: Int!) {
            findCreditById(id: $id) {
              creditId
              dayLimit
              moneyBase
              paymentDate
              startCountingDate
              payAgreementDate
              capCurrentStatus {
                stateId
                stateName
              }
              additionalPayments
              arrearsPayments
              capAccount {
                accountId
                fullName
                email
                cellphone
                diffScore
                capCurrentStatus {
                  stateId
                  stateName
                }
                documentValue
                capClientCategory {
                  catName
                }
              }
              capS3ProofPayment {
                keyName
              }
            }
          }
        `,
        variables: {
          id: this.$route.params.creditId
        }
      })
      .then(data => {
        this.currentCredit = data.data.findCreditById;
        this.additionalPayments = Constants.currencyValue(
          this.currentCredit.additionalPayments
        );
        if (this.currentCredit.arrearsPayments != 0)
          this.arrearsPayments = Constants.currencyValue(
            this.currentCredit.arrearsPayments
          );
        this.moneyBase = Constants.currencyValue(this.currentCredit.moneyBase);
        this.$apollo
          .query({
            query: gql`
              query findScoreFromAccount($accountId: Int!) {
                findScoreFromAccount(accountId: $accountId) {
                  accountId
                  score
                }
              }
            `,
            variables: {
              accountId: this.currentCredit.capAccount.accountId
            }
          })
          .then(data => {
            this.clientScore = data.data.findScoreFromAccount;
          });

        if (this.currentCredit.payAgreementDate)
          this.payAgreementTitle = "Acuerdo de Pago";
        else this.payAgreementTitle = "Contáctanos";

        this.$apollo
          .query({
            query: gql`
              query getFromToCurrentStateCredit($currentState: Int!) {
                getFromToCurrentStateCredit(currentState: $currentState) {
                  id: stateId
                  name: stateName
                  description: stateDescription
                }
              }
            `,
            variables: {
              currentState: this.currentCredit.capCurrentStatus.stateId
            }
          })
          .then(data => {
            this.statusList = data.data.getFromToCurrentStateCredit;
          });
        this.keyName =
          "contratos/" +
          this.currentCredit.capAccount.documentValue +
          "/" +
          this.currentCredit.capAccount.fullName +
          " " +
          this.currentCredit.creditId +
          " firmado.pdf";
        this.$apollo
          .query({
            query: gql`
              query getS3File($keyName: String!) {
                getPresignedUrl(keyName: $keyName)
              }
            `,
            variables: {
              keyName: this.keyName
            }
          })
          .then(data => {
            this.routePresignedUrl = data.data.getPresignedUrl;
            this.imageRegular = "./img/capital77/file-check-icon.webp";
          })
          .catch(error => {
            this.keyName =
              "contratos/" +
              this.currentCredit.capAccount.documentValue +
              "/" +
              this.currentCredit.capAccount.fullName +
              " " +
              this.currentCredit.creditId +
              ".pdf";
            this.$apollo
              .query({
                query: gql`
                  query getS3File($keyName: String!) {
                    getPresignedUrl(keyName: $keyName)
                  }
                `,
                variables: {
                  keyName: this.keyName
                }
              })
              .then(data => {
                this.routePresignedUrl = data.data.getPresignedUrl;
                this.imageRegular = "./img/capital77/file-check-icon.webp";
              })
              .catch(error => {
                //URL inválido error.message
              });
          });
        if (this.currentCredit.capS3ProofPayment)
          this.$apollo
            .query({
              query: gql`
                query getS3File($keyName: String!) {
                  getPresignedUrl(keyName: $keyName)
                }
              `,
              variables: {
                keyName: this.currentCredit.capS3ProofPayment.keyName
              }
            })
            .then(data => {
              this.proofPresignedUrl = data.data.getPresignedUrl;
              //this.imageRegular = "./img/capital77/file-check-icon.png"; Debería tener imagen propia?
            })
            .catch(error => {
              console.log("cae aqupu");
              //URL inválido error.message
            });
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          false
        );
      });
  },
  watch: {
    keyName() {
      if (this.keyName.endsWith("firmado.pdf")) {
        this.contractTitle = "Contrato Firmado: ";
      } else this.contractTitle = "Contrato Generado: ";
    },
    moneyBase() {
      this.sumTotal = Constants.currencyValue(
        this.currentCredit.moneyBase +
          this.currentCredit.additionalPayments +
          this.currentCredit.arrearsPayments
      );
    }
  }
};
</script>
<style></style>
